import { loadActiveSkin } from "@/lib/theme";
import { Footer } from "./footer";
import { FooterV2 } from "./v2/footer-v2";

/**
 * Skin-aware footer — picks V1 or V2 layout based on the active skin
 * stored in Setting.theme.active_skin.
 */
export async function SiteFooter() {
  const skin = await loadActiveSkin();
  if (skin === "v2") return <FooterV2 />;
  return <Footer />;
}
